import { IApplicationState } from '../../types/redux';

export const selectIsMapOpen = (state: IApplicationState) => state.map.isOpen;
